import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AccessTokensService } from './../../../services/access-tokens.service';
import { Auth } from '@angular/fire/auth';
import { AppService } from '../../../../app.service';

@Injectable({
  providedIn: 'root',
})
export class IsLoggedInGuard implements CanActivate {
  constructor(
    private router: Router,
    private fireAuth: Auth,
    private appService: AppService,
    // private accountsAppService: AccountsAppService,
    private accessTokensService: AccessTokensService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return new Observable((observer) => {
      this.fireAuth.onAuthStateChanged(async (user) => {
        if (user) {
          // User is Logged In
          if (state.url.includes('/auth')) {
            // User is on an auth page (e.g. /auth/login, /auth/signup)
            // This typically happens right after login/signup action.
            const onboardingPending =
              localStorage.getItem('onboarding_pending');
            if (onboardingPending === 'true') {
              // New user who just signed up, redirect to onboarding.
              // The 'onboarding_pending' flag will be cleared by AppService later.
              this.router.navigateByUrl('/onboarding');
              observer.next(false); // Deny activation of the current /auth route.
            } else {
              // Existing user logging in, or flag not set, redirect to home.
              // console.log(onboardingPending);
              // this.router.navigateByUrl('/splash', {
              //   skipLocationChange: true,
              // });
              // this.router.navigateByUrl('/home');
              observer.next(false); // Deny activation of the current /auth route.
            }
          } else {
            // User is logged in and trying to access a protected route directly
            // (e.g., /home, /onboarding, /settings). Allow access.
            // AppService will handle further onboarding logic if needed when /home is loaded.
            observer.next(true);
          }
        } else {
          // User is NOT Logged In
          if (state.url.includes('/auth')) {
            // User is trying to access an auth page (e.g., /auth/login), allow it.
            observer.next(true);
          } else {
            // User is trying to access any other page (which would be protected by this guard),
            // redirect to /auth.
            this.router.navigateByUrl('/auth');
            observer.next(false);
          }
        }
        observer.complete();
        // Return is not strictly necessary here as observer.complete() is called in all paths
        // but kept for consistency if other async operations were to be added after the if/else.
        return;
      });
    });
  }
}
